import Model, { attr } from '@ember-data/model';

export default class Announcement extends Model {
  @attr('string') message;
  @attr('string') title;
}
